<template>
  <TryOutProfileForm :bundle="bundle" :bundle-id="bundleId" :show-email-form="false" user-flow-name="profile_shop">
    <template #buttons="{ onTryClick, onBuyClick }">
      <div class="flex w-full flex-col gap-3 md:flex-row">
        <IAIButton
          class="action-button"
          variant="primary"
          :label="t('pages.profile-shop.profile-header.buy-now')"
          @click="onBuyClick"
        />

        <IAIButton
          class="action-button"
          variant="outline"
          :label="t('pages.profile-shop.profile-header.try-first')"
          @click="onTryClick"
        />
      </div>
    </template>
  </TryOutProfileForm>
</template>

<script setup lang="ts">
import { t } from "@/locales/vue";
import { IAIButton } from "@/core-ui-vue";
import { IBundleDetailesResponse } from "@/features/sell-a-profile/services/api";
import TryOutProfileForm from "@/features/sell-a-profile/components/bundle-details/TryOutProfileForm.vue";

defineProps<{
  bundle: IBundleDetailesResponse;
  bundleId: string;
}>();
</script>

<style lang="scss" scoped>
.action-button {
  @apply w-full min-w-[7rem] md:w-auto;
}
</style>
